import { createFileRoute } from "@tanstack/react-router";

import { Button } from "@/components/ui/button";
import { buildOidcLoginUrlForPath } from "@/lib/api/auth-redirect";

function AuthErrorPage() {
  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-4 p-4">
      <div className="max-w-md w-full space-y-4">
        <h1 className="text-2xl font-bold">Connexion interrompue</h1>
        <p className="text-muted-foreground">
          La session de connexion a expiré ou votre navigateur a bloqué les
          cookies. Réessayez ; si le problème persiste, autorisez les cookies
          pour ce site.
        </p>
        <Button
          nativeButton={false}
          render={
            <a href={buildOidcLoginUrlForPath("/")}>Réessayer la connexion</a>
          }
        />
      </div>
    </div>
  );
}

export const Route = createFileRoute("/_public/auth/error")({
  component: AuthErrorPage,
});
